import { PhotoListCarousel } from "../../../../../../../../shared/ui/strspykit/PhotoListCarousel"

interface PictureListCarouselProps {
    pictures: any
}

export const PictureListCarousel = (props: PictureListCarouselProps): JSX.Element => {
    const {
        pictures
    } = props

    return (
        <PhotoListCarousel
            photos={pictures}
        />
    )
}